import React, { Component } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./MainScreen.scss";

export default class MainScreen extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    render() {
        return (
            <section className="section section-welcome">
                <Header />
                <div className="padding">
                    <div className="container">
                        <div className="headline">
                            <div className="head">מצעד נבחרי השנה של</div>
                            <div className="logo"></div>
                            <div className="slogen">
                                <div className="text">אתר הנוער של ישראל</div>
                            </div>
                            <div className="todo">
                                בחרו את המועמד/ת המועדפ/ת עליך בכל קטגוריה
                            </div>
                            <div className="mouse" onClick={()=>{
                                this.props.slideDwon({
                                    isBusy: true,
                                    isActive: "swu"
                                });
                            }}></div>
                        </div>
                    </div>
                </div>
                <Footer />
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Screen/MainScreen.jsx